import React from 'react'
import WeInNumberColumns from '../WeInNumbersComponents/WeInNumberColumns'
import OurAchivements from '../WeInNumbersComponents/OurAchivements'


function WeInNumbers() {



    return (
        <>
            <div className="flex flex-col px-5 mt-10">
                <WeInNumberColumns />
                <OurAchivements />
            </div>
        </>
    )
}

export default WeInNumbers